export default __webpack_public_path__ + "static/media/warning.3a4f261d.jpg";